import { useState } from 'react';
import { handleMultipleSignatures } from './SignatureFunc';

export const useSignature = () => {
    const [uploadStatus, setUploadStatus] = useState("idle");
    const [uploadError, setUploadError] = useState("");
    const [selectedSignDocument, setSelectedSignDocument] = useState(null);

    // Multiple signature method
    const signDocument = async (file, signaturesArray) => {
        await handleMultipleSignatures(file, signaturesArray, { setUploadStatus, setUploadError, setSelectedSignDocument });
    };

    const resetSignatureState = () => {
        setUploadStatus("idle");
        setUploadError("");
        setSelectedSignDocument(null);
    };

    return {
        uploadStatus,
        uploadError,
        selectedSignDocument,
        signDocument,
        resetSignatureState,
    };
};